import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ErrorService } from '@app/core/service/error.service';
import { environment } from '@env/environment';
import { AuthenticationService } from '../business/user/authentication.service';
import { OrderService } from '../business/order/order.service';

@Injectable()
export class ServerErrorInterceptor implements HttpInterceptor {

    constructor(
        private router: Router,
        private errorService: ErrorService,
        private orderService: OrderService

    ) {
    }

    intercept(
        request: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        request = request.clone();

        return next.handle(request).pipe(
            tap(
                () => { },
                errorResponse => {


                    // 🚫 Ignore si la requête demande de bypass l’interceptor
                    if (request.headers.has('X-Bypass-Global-Error') && request.headers.get('X-Bypass-Global-Error') === 'true') {
                        return; // ❌ On laisse le composant gérer lui-même
                    }
                    // If request responseType is arraybuffer (a file was expected as a response), and the request return an error,
                    // decode the response as it will be a JSON as an utf-8 uintArray
                    if (request.responseType === 'arraybuffer') {
                        if ('TextDecoder' in window) {
                            // Use TextDecoder if the browser support exist
                            let dataView = new DataView(errorResponse.error);
                            let decoder = new TextDecoder('utf8');
                            errorResponse['error'] = JSON.parse(decoder.decode(dataView));
                        } else {
                            // Use polyfill if TextDecoder not supported
                            let decoder = new TextDecoder();
                            let dataView = new DataView(errorResponse.error);
                            errorResponse['error'] = JSON.parse(decoder.decode(dataView));
                        }
                    }

                    // if server error has message then display it inside a toaster
                    if (
                        errorResponse.error &&
                        errorResponse.error.errorMessage &&
                        errorResponse.error.errorMessage !== ''
                    ) {
                        this.errorService.addMessage(errorResponse.error.errorMessage);
                    }

                    // To prevent keeping an invalid order, remove it from context if it doesn't exists anymore
                    if (
                        errorResponse.error &&
                        errorResponse.error.errorCode === environment.noOrderErrorCode
                    ) {
                        // Redirect to dashboard to be safe if the previous page needed the current order
                        this.router.navigateByUrl('/context');

                        // If the order code doesn't exist anymore, remove it from context
                        // To remove from context we use a bahavior subject instead of injecting contextService here
                        // which would create a recursion overflow: Maximum call stack size exceeded
                        this.orderService.orderInvalid$.next(true);
                    }
                }
            )
        );
    }
}
